import CloseIcon from "mdi-react/CloseIcon";
import styles from "./CloseButtonIcon.module.scss";

interface ICloseButtonIcon {
  onRemove?: () => void;
}

const CloseButtonIcon = ({ onRemove }: ICloseButtonIcon) => (
  <span className={styles.closeButtonIcon} onClick={onRemove}>
    <CloseIcon />
  </span>
);

export default CloseButtonIcon;
